import React, { useMemo } from 'react';
import { match } from 'ts-pattern';
import { RouteMap } from 'constants/Routes';
import Breadcrumbs from 'styled/components/Breadcrumbs';
import type { ProvidersRouteParams } from 'types';
import {
  caseNull,
  caseKind,
  caseKindState,
  caseKindStateCity,
  encode,
  getSEOKind,
} from './utils';
import { fullStateName } from 'pages/providers/utils';

interface Props {
  rp: ProvidersRouteParams;
}

const ProviderPageBreadcrumbs = ({ rp }: Props) => {
  const crumbs = useMemo(() => {
    const providers = {
      label: 'Specialists A to Z',
      ariaLabel: 'Specialists A to Z',
      to: RouteMap.PROVIDERS.base,
      isActive: false,
    };
    const kind = {
      label: getSEOKind(rp.kind) || '',
      ariaLabel: rp.kind || '',
      to: `${RouteMap.PROVIDERS.base}/${encode(rp.kind)}`,
      isActive: false,
    };
    const state = {
      label: fullStateName(rp.state || ''),
      ariaLabel: rp.state || '',
      to: `${RouteMap.PROVIDERS.base}/${encode(rp.kind)}/${rp.state}`,
      isActive: false,
    };
    const city = {
      label: rp.city || '',
      ariaLabel: rp.city || '',
      to: `${RouteMap.PROVIDERS.base}/${encode(rp.kind)}/${rp.state}/${encode(rp.city)}`,
      isActive: false,
    };
    const crumbs = match(rp)
      .with(caseNull, () => [providers])
      .with(caseKind, () => [providers, { ...kind, isActive: true }])
      .with(caseKindState, () => [
        providers,
        kind,
        { ...state, isActive: true },
      ])
      .with(caseKindStateCity, () => [
        providers,
        kind,
        state,
        { ...city, isActive: true },
      ])
      .otherwise(() => []);
    return crumbs;
  }, [rp]);

  return <Breadcrumbs crumbConfig={crumbs} />;
};

export default ProviderPageBreadcrumbs;
